import { Language } from '../context/LanguageContext';

export interface BiggestGemstoneTranslations {
  backgroundTitle: {
    firstLine: string;
    secondLine: string;
  };
  intro: {
    title: {
      firstLine: string;
      secondLine: string;
    };
    description: string;
  };
  timeline: Array<{
    title: {
      firstLine: string;
      secondLine: string;
    };
    description: string;
  }>;
}

export const biggestGemstoneTranslations: Partial<Record<Language, BiggestGemstoneTranslations>> = {
  en: {
    backgroundTitle: {
      firstLine: "THE SECRET",
      secondLine: "RAINBOW"
    },
    intro: {
      title: {
        firstLine: "THE SECRET RAINBOW,",
        secondLine: "THE WORLD'S BIGGEST FACETED GEMSTONE",
      },
      description:
        "The gemstone which holds the crown amongst the jewels, the biggest of all faceted gems, is the Secret Rainbow. This most exceptional gem is not only the Mother of all Gems by virtue of its size. It also has a fantastic Rainbow which is very rarely found in a gemstone. The interference-colours, seen in different places in the gem, when the light hits the stone in a particular direction, must be some of the most intense ever found in a jewel.",
    },
    timeline: [
      {
        title: {
          firstLine: "THE SECRET RAINBOW,",
          secondLine: "A NOBLE-TOPAZ OF 50,200 CARAT",
        },
        description: `The Secret Rainbow, a noble-topaz of 50,200 carat, weighs more than one and a half times as much as the second biggest gem, the El Dorado with 31,000 carat. 
The particular cut of the biggest jewel on earth is a combination of a step-cut on the front side and an arrangement of culet-grooves in its back. The back side-grooves are carved with the so-called critical angle of topaz, which gives the best reflection of light.
When placed upright, the arrangement of the grooves suggests a sunrise at early morning, with the rainbow unfolding high above in the sky. As a third element, a dragon is carved into the topaz on one side, playing with the rainbow.`,
      },
      {
        title: {
          firstLine: "THE DRAGON,",
          secondLine: "A SUPERNATURAL POWER",
        },
        description: `A dragon is a mythological figure which appears in all ancient cultures all around the world. Since there is no animal that could have served as a prototype for the dragon beliefs, scientists wonder from where this mythical figure comes. It appears in the culture of the Mayas as well as on the other side of the globe, in Australia. It is there in China and on the Polynesian Islands, in India, Europe, Africa; it figures in the belief of the old Vikings and in Christianity – it is just everywhere!`,
      },
      {
        title: {
          firstLine: "THE DRAGON,",
          secondLine: "UNIVERSAL ARCHETYPE",
        },
        description: `And how is it that this mythical being pops up independently in all cultures with exactly the same characteristics? If there is no prototype in the outside world, then the mythical figure of a dragon must be a replica of an example from the inner worlds! Obviously dragons exist—like fairies or goblins—which also appear in all cultures, but it takes a well-trained inner eye to see them.`,
      },
      {
        title: {
          firstLine: "THE DRAGON,",
          secondLine: "ITS DIFFERENT FACES",
        },
        description: `And like other entities, dragons represent a particular force or aspect in the occult worlds. Although the physiognomy of all dragons is pretty much the same—including their character features—the evaluation of the dragon changes drastically from culture to culture. While in Europe the dragon is regarded as a wild monster creating chaos and destruction, in Asia it is considered a wise and gentle being, a symbol for luck and prosperity. A few character traits of the dragon, however, are common in all cultures: its affinity to treasures and its instinct to guard and defend them.`,
      },
      {
        title: {
          firstLine: "THE RAINBOW,",
          secondLine: "A BRIDGE BETWEEN HEAVEN AND EARTH",
        },
        description: `The rainbow symbolizes in all cultures a connection between the divine and the earthly. In Greek mythology, the goddess Iris—the heavenly messenger—descends on the rainbow. In Viking mythology, the rainbow is the bridge between Middle Earth (our world) and Asgard, the world of the gods.`,
      },
      {
        title: {
          firstLine: "THE RAINBOW,",
          secondLine: "GUARDING THE HIGHEST TREASURE",
        },
        description: `The picture of a dragon in front of a rainbow can symbolize many things. Here, the symbolic image is that of a dragon guarding the most valuable treasure that exists: the entrance to the divine worlds, to wisdom, knowledge, unlimited magical powers, and unlimited bliss. The dragon guards this treasure by directing our attention toward the small details of daily life so that we may not find the door to the inner worlds hidden within us.`,
      },
      {
        title: {
          firstLine: "THE 'SECRET RAINBOW'",
          secondLine: "AND ITS SYMBOLISM",
        },
        description: `The "body" of the world's biggest gem—with its special cut depicting a sunrise—stands for the beginning of the day, for time, for our day or our time, for life itself.`,
      },
      {
        title: {
          firstLine: "AT THE HEART",
          secondLine: "OF THE GEM",
        },
        description: `At the heart of the gem, at the center of our life, stands (symbolized by the rainbow patch) the one great goal toward which we all travel: the entrance to higher levels of consciousness, to the divine realms, to unlimited bliss, and the transformation of all limitations and shortcomings.`,
      },
      {
        title: {
          firstLine: "THE DRAGON",
          secondLine: "GUARDS THE TREASURE",
        },
        description: `However, this entrance—the biggest treasure everyone carries in their heart—is guarded by a dragon that ensures we never find it. By its play and the play of life, it diverts our attention to the small details of life so that we are blind to the door leading to the inner worlds; a door that is hidden yet, from a certain angle, reveals an iridescent light indicating that it is actually wide open!`,
      },
      {
        title: {
          firstLine: "DISCOVERING THE WORLD'S",
          secondLine: "BIGGEST GEMSTONE",
        },
        description: `There are things in life that happen only once, and once they occur, you know there will never be a second time! When, in 2017, a raw topaz of unusual size and excellent purity crossed Niveau élevé's path, the huge potential embedded within this future king of all gems was not apparent to the Afghan raw-stone dealer who offered it. The stone had been discovered a year earlier in Brazil (Minas Gerais) and had changed hands several times—but no one had the competence or vision to transform it into the biggest gemstone ever polished.`,
      },
      {
        title: {
          firstLine: "THE PRICE OF",
          secondLine: "CLEAN TOPAZ ROUGH",
        },
        description: `So it came that the raw topaz was offered at the standard price for clean rough—a price at which the stone, usually sawn into small pieces, polished into gems for rings or pendants, irradiated, and then sold as "blue-topaz" in tele-shopping or by big discounters, was marketed. But that was not what Niveau élevé had in mind! Being fully into big gemstone sculptures, they knew that the three biggest known gems were all noble-topaz, and this amazing piece of rough could eventually beat them all! At that time, the world's largest gemstone was the El Dorado in a special collection in Madrid, weighing 31,000 carats. The "American Golden Topaz" of 22,892 carats, displayed at the National Museum of National History in Washington, came in second.`,
      },
      {
        title: {
          firstLine: "THE LONG WAY",
          secondLine: "TO POLISHING",
        },
        description: `After the mega-gem was purchased, it still took five years to polish it into what it is now. There were several major difficulties. The most critical was that topaz always has a basal cleaving plane running through it—if you apply force along this plane when cutting, the topaz will simply split in two. The operation began with a full year of planning where the stone was studied and the cutting and polishing prepared.`,
      },
      {
        title: {
          firstLine: "PREPARING FOR",
          secondLine: "THE BIG TASK",
        },
        description: `Planning a big jewel—whether a diamond or gemstone—is always complicated and time-consuming. A small mistake can ruin the entire stone. In our case, several hurdles had to be overcome: first, there was no machinery to polish such a stone; no equipment existed for a gem of this magnitude. A new machine had to be designed and constructed. Second, there was no gemstone-polisher experienced enough with such huge topaz. The fear was that polishing tensions could lead to the stone breaking. The third challenge was to develop a design that wouldn't be boring—after all, a small gem with small facets sparkles far better than a big one.`,
      },
      {
        title: {
          firstLine: "SAMPLING OF",
          secondLine: "THE FINAL RESULT",
        },
        description: `Niveau élevé started by importing special glass from Japan with the same refractive index as topaz (1.63). Then, five replicas of the rough topaz were cast in glass so that they could be polished in different cuts—primarily to test the new machine, and secondarily to choose the most beautiful geometrical shape for the gemstone.`,
      },
      {
        title: {
          firstLine: "FAILED ATTEMPT",
          secondLine: "",
        },
        description: `But the attempt failed. The glass crystallized during cooling and became like porcelain, so the process had to be repeated with a different glass type.`,
      },
      {
        title: {
          firstLine: "POLISHING",
          secondLine: "THE GLASS-SAMPLES",
        },
        description: `Polishing the glass-samples itself took more than two years. Over and over, the new polishing machine had to be optimized, new diamond-impregnated polishing wheels had to be made, or the ultra-fine threading of the 3-axis cross-slide improved.`,
      },
      {
        title: {
          firstLine: "POLISHING THE",
          secondLine: "BIGGEST GEM EVER",
        },
        description: `Finally, in 2020, the actual polishing of the big topaz began. For polishing rare and significant gemstones, there is only one place in the world—Idar-Oberstein. For such a complex task, the most competent and experienced specialist (who still knows the traditional art of fine gem cutting) was chosen: the teacher and headmaster of Idar-Oberstein's Gem-Cutting School, Mr. Jürgen Christmann.`,
      },
      {
        title: {
          firstLine: "TEAM-WORK",
          secondLine: "",
        },
        description: `But handling a gemstone weighing nearly 20 Kg is a daunting task. So Niveau élevé enlisted a top glass-cutting artist, Samuel Weisenborn, who agreed to assist Jürgen.`,
      },
      {
        title: {
          firstLine: "DRAGON CARVING",
          secondLine: "",
        },
        description: `The dragon on the gemstone was carved by Mrs. Iris Hartenberger.`,
      },
      {
        title: {
          firstLine: "TWO YEARS UNTIL",
          secondLine: "FINAL POLISH",
        },
        description: `It took two years until the final finishing polish was completed just a few days before Niveau élevé's summer event in mid-August 2023. All three experts did a marvellous job, delivering a gem that surpassed all expectations!`,
      },
      {
        title: {
          firstLine: "CERTIFICATION",
          secondLine: "",
        },
        description: `In May 2024, Gubelin in Lucerne, Switzerland—the world's most reputed gemstone testing laboratory—certified the Secret Rainbow and issued an outstanding report and comment.`,
      },
      {
        title: {
          firstLine: "LARGEST TOPAZ",
          secondLine: "EVER TESTED",
        },
        description: `It was stated that the stone is extremely large, has a high degree of transparency (with few eye-visible inclusions), and that such gem-quality topaz is rarely seen in such an exceptional size. Moreover, this is the largest topaz ever tested by the Gubelin lab.`,
      },
      {
        title: {
          firstLine: "THE OCCULT POWERS OF TOPAZ",
          secondLine: "ACCORDING TO HISTORY",
        },
        description: `Gemstones have an effect. Today we mostly appreciate their aesthetic appeal, fire, light play, deep or rare colours, and harmonious geometry. Besides their high value and rarity, these aspects contribute to their prestige. In ancient times, stones were also primarily valued for their occult powers.
The ancient Greeks believed topaz gave them strength, cured insomnia, and healed mental diseases. The Romans thought it could protect against poison and would change colour when danger was near. In ancient Egypt, the golden topaz was believed to receive its glow from the sun god Ra—making it a powerful talisman against harm. The Egyptians also ascribed supernatural powers to this gemstone.`,
      },
      {
        title: {
          firstLine: "TOPAZ IN ANCIENT INDIA",
          secondLine: "AND BEYOND",
        },
        description: `In India, topaz was worn over the heart—a symbol for long life, beauty, and intelligence. In late medieval times and during the Renaissance in Europe, topaz was said to protect against evil spells and anger.
In any case, it is clear that a beautiful, rare, and valuable gemstone carries a certain power—whether that effect is psychological (boosting self-confidence) or metaphysical/occult remains immaterial. We simply cannot see behind the curtain that limits our understanding of all these invisible mechanisms.`,
      },
      {
        title: {
          firstLine: "THE ETYMOLOGICAL ORIGIN",
          secondLine: "OF THE NAME TOPAZ",
        },
        description: `There are two theories regarding where the name "Topaz" originated—perhaps both are true. We know that Pliny the Elder wrote in his "historia naturalis" that, according to Juba, there is a crystal on a certain island in the Red Sea as well as on another nearby island that produces the precious stone known as the "topazus"; that island was called in Ancient Greek Τοπάζιος (Topázios) or Τοπάζιον (Topázion).`,
      },
      {
        title: {
          firstLine: "NAME 'TOPAZ'",
          secondLine: "LINKED TO SANSKRIT 'TAPAS'",
        },
        description: `According to Alexander Polyhistor, an ancient Greek writer, the etymological origin of the name topaz—for both the gemstone and the island believed to produce it—came from ancient Sri Lanka, which exported topaz to Egypt and Greece. This indicates that the name topaz is related to the Sanskrit word तपस् "tapas", meaning "heat" or "fire".
If this is the true origin of the name topaz, there is an interesting parallel to the symbolism of the Secret Rainbow: the main meaning of the Sanskrit word Tapasya (तपस्य), which literally means "to generate heat", is the effort to reach higher levels of consciousness, to achieve self-realization, and ultimately, to experience union with the Divine.`,
      },
      {
        title: {
          firstLine: "TO OWN THE WORLD'S",
          secondLine: "BIGGEST FACETED GEMSTONE",
        },
        description: `To own a jewel or a treasure is one of the most intrinsic human instincts through all of history—even today. While various mechanisms may explain this desire, possessing a powerful gemstone confers strength, self-confidence, and inner power that goes beyond mere psychology. And let us be happy that not all mysteries have been discovered or explained. Let us simply appreciate that a fantastic gem has its own power, whatever that may be!
To own the world's biggest faceted gemstone naturally adds value and power to the Niveau élevé brand. Moreover, one of the declared aims of Niveau élevé is to work with that which lies beyond the visible or explicable. In short, owning a piece of jewellery or a watch from Niveau élevé means owning part of—and tapping into—the power of the Secret Rainbow! Modern physics (via quantum-optical experiments) has proven that parts of the same origin remain linked even over millions of kilometers. Thus, we believe every piece of Niveau élevé carries a trace of every other product from the same origin, and we hope that the strength of this topaz—the largest of all faceted gems—manifests in every member of the Niveau élevé family.`,
      },
    ],
  },
  de: {
    backgroundTitle: {
      firstLine: "DER SECRET",
      secondLine: "RAINBOW"
    },
    intro: {
      title: {
        firstLine: "DER 'SECRET RAINBOW',",
        secondLine: "DER GRÖSSTE FACETTIERTE EDELSTEIN DER WELT",
      },
      description:
        "Der Edelstein, der den Rekord der Größe unter den Juwelen hält, der größte aller facettierten Edelsteine, ist der Secret Rainbow. Dieses höchst außergewöhnliche Juwel ist nicht nur aufgrund seiner Größe die Mutter aller Edelsteine. Es verfügt außerdem über einen fantastischen Regenbogen, der bei Edelsteinen sehr selten zu finden ist. Die Interferenzfarben, die an verschiedenen Stellen sichtbar werden, wenn das Licht in einer bestimmten Richtung auf den Stein fällt, gehören zu den intensivsten, die je in einem Edelstein gefunden wurden.",
    },
    timeline: [
      {
        title: {
          firstLine: "DER SECRET RAINBOW,",
          secondLine: "EIN EDEL-TOPAS VON 50.200 KARAT",
        },
        description: `Der Secret Rainbow, ein Edeltopas von 50.200 Karat, wiegt mehr als eineinhalb Mal so viel wie der zweitgrößte Edelstein, der El Dorado mit 31.000 Karat.
Der besondere Schliff des größten Edelsteins der Welt ist eine Kombination aus einem Treppenschliff auf der Vorderseite und einer Anordnung von Lamellen auf der Rückseite. Die Rillen auf der Rückseite sind mit dem sogenannten kritischen Winkel des Topas geschliffen, der die beste Lichtreflexion gewährleistet.
In aufrechter Position suggeriert die Anordnung der Rillen einen Sonnenaufgang am frühen Morgen, während sich der Regenbogen hoch oben am Himmel entfaltet. Als drittes Element ist auf einer Seite ein Drache in den Topas geschnitzt, der mit dem Regenbogen spielt.`,
      },
      {
        title: {
          firstLine: "DER DRACHE,",
          secondLine: "EINE ÜBERNATÜRLICHE MACHT",
        },
        description: `Der Drache ist eine mythische Figur, die in allen alten Kulturen auf der ganzen Welt vorkommt. Da es kein Tier gibt, das als Vorbild für den Drachenglauben gedient haben könnte, fragen sich Wissenschaftler, woher diese mythologische Figur stammt. Er taucht in der Kultur der Maya ebenso auf wie an anderen Orten – in Australien, China, auf den polynesischen Inseln, in Indien, Europa und Afrika; er erscheint im Glauben der alten Wikinger und im Christentum – er ist einfach überall!`,
      },
      {
        title: {
          firstLine: "DER DRACHE,",
          secondLine: "UNIVERSELLER ARCHETYP",
        },
        description: `Und wie kommt es, dass dieses mythische Wesen in allen Kulturen mit exakt denselben Eigenschaften auftaucht? Wenn es in der realen Welt kein Vorbild gibt, muss die mythische Figur des Drachens eine Nachbildung eines inneren Musters sein! Offensichtlich gibt es also Drachen – wie auch Feen oder Kobolde –, die in allen Kulturen erscheinen, doch man muss ein gut geschultes inneres Auge besitzen, um sie zu erkennen.`,
      },
      {
        title: {
          firstLine: "DER DRACHE,",
          secondLine: "SEINE VERSCHIEDENEN GESICHTER",
        },
        description: `Wie andere Wesenheiten repräsentieren Drachen in den okkulten Welten eine bestimmte Kraft oder einen Aspekt. Obwohl die Physiognomie und auch die Charaktereigenschaften der Drachen fast identisch sind, ändert sich ihre Bewertung von Kultur zu Kultur drastisch. Während in Europa der Drache als wildes Ungeheuer gilt, das Chaos und Zerstörung verbreitet, wird er in Asien als weises und sanftes Wesen verehrt, als Symbol für Glück und Wohlstand. Einige Charaktereigenschaften – etwa seine Affinität zu Schätzen sowie der Instinkt, diese zu bewachen – sind in allen Kulturen jedoch gemeinsam.`,
      },
      {
        title: {
          firstLine: "DER REGENBOGEN,",
          secondLine: "EINE BRÜCKE ZWISCHEN HIMMEL UND ERDE",
        },
        description: `Der Regenbogen symbolisiert in allen Kulturen die Verbindung zwischen dem Göttlichen und dem Irdischen. In der griechischen Mythologie steigt die Göttin Iris, die himmlische Botin, auf dem Regenbogen zu uns herab. In der Wikinger-Mythologie ist der Regenbogen die Brücke zwischen Mittelerde (unserer Welt) und Asgard, der Welt der Götter.`,
      },
      {
        title: {
          firstLine: "DER REGENBOGEN,",
          secondLine: "DER DEN WERTVOLLSTEN SCHATZ BEWACHT",
        },
        description: `Das Bild eines Drachens vor einem Regenbogen kann vieles symbolisieren. Hier ist das Bild eines Drachens, der den wertvollsten Schatz bewacht – den Zugang zu den göttlichen Welten, zu Weisheit, Wissen, zu unbegrenzten magischen Kräften und zu unbegrenzter Glückseligkeit. Der Drache bewacht diesen Schatz, indem er unsere Aufmerksamkeit auf die kleinen Alltagsdetails lenkt, sodass wir das Tor zu den inneren Welten, das in uns verborgen liegt, nicht finden.`,
      },
      {
        title: {
          firstLine: "DER 'SECRET RAINBOW'",
          secondLine: "UND SEINE SYMBOLIK",
        },
        description: `Der Stein an sich, mit seinem speziellen Schliff, der einen Sonnenaufgang darstellt, steht für den Beginn des Tages, für die Zeit, für unseren Tag oder unsere Zeit, für das Leben als solches.`,
      },
      {
        title: {
          firstLine: "IM HERZEN",
          secondLine: "DES JUWELS",
        },
        description: `Im Herzen des Edelsteins, im Zentrum unseres Lebens, steht – symbolisiert durch den Regenbogeneffekt – das große Ziel, auf das wir alle zusteuern: der Eintritt in höhere Bewusstseinsebenen, in die göttlichen Reiche, in unbegrenzte Glückseligkeit sowie die Transformation aller Begrenzungen und Unzulänglichkeiten.`,
      },
      {
        title: {
          firstLine: "DER DRACHE",
          secondLine: "BEWACHT DEN SCHATZ",
        },
        description: `Doch dieser Eingang, der größte Schatz, den jeder in seinem Herzen trägt, wird von einem Drachen bewacht, der dafür sorgt, dass wir ihn nicht finden. Durch sein Spiel und das Spiel des Lebens lenkt er unsere Aufmerksamkeit auf die kleinen Details, sodass uns der Zugang zu den inneren Welten verborgen bleibt – ein Zugang, der im richtigen Winkel ein schillerndes Licht zeigt, das offenbart, dass die Tür in Wirklichkeit weit offensteht!`,
      },
      {
        title: {
          firstLine: "DIE ENTDECKUNG",
          secondLine: "DES GRÖSSTEN EDELSTEINS DER WELT",
        },
        description: `Es gibt Dinge im Leben, die man nur einmal macht – und von denen man weiß, dass es sie nie ein zweites Mal geben kann! Als 2017 ein Rohtopas von ungewöhnlicher Größe und hervorragender Reinheit den Weg von Niveau élevé kreuzte, war dem afghanischen Rohsteinhändler nicht bewusst, welches enorme Potenzial in diesem zukünftigen König aller Edelsteine steckte. Der Stein wurde vor einem Jahr in Brasilien (Minas Gerais) entdeckt und hatte bereits mehrfach den Besitzer gewechselt. Doch niemand besaß die Kompetenz oder Vision, ihn zum größten jemals geschliffenen Edelstein zu machen.`,
      },
      {
        title: {
          firstLine: "DER PREIS DES",
          secondLine: "ROHSTEINS",
        },
        description: `So kam es, dass der Rohtopas zu einem Preis angeboten wurde, der für sauberen Roh-Topas üblich ist – ein Preis, bei dem der Topas normalerweise in kleine Stücke gesägt, zu Edelsteinen für Ringe oder Anhänger geschliffen, bestrahlt und dann als Blautopas im Tele-Shopping oder bei Discountern verkauft wird.
Doch das war nicht das, was Niveau élevé sich vorstellte! Da Niveau élevé bereits zahlreiche große Edelsteinskulpturen geschliffen und verkauft hatte, wusste man, dass die drei größten bekannten Edelsteine allesamt Edeltopase sind – und dieses erstaunliche Rohstück könnte sie alle übertreffen! Damals lag der größte Edelstein der Welt als El Dorado in einer speziellen Sammlung in Madrid, mit einem Gewicht von 31.000 Karat. An zweiter Stelle stand der "American Golden Topaz" mit 22.892 Karat, der im National Museum of National History in Washington ausgestellt ist.`,
      },
      {
        title: {
          firstLine: "DER LANGE WEG",
          secondLine: "BIS ZUM SCHLEIFEN",
        },
        description: `Nach dem Kauf des Mega-Juwels dauerte es noch fünf Jahre, bis der Stein geschliffen wurde und zu dem wurde, was er heute ist. Dabei gab es zahlreiche Schwierigkeiten. Die kritischste war die Tatsache, dass ein Topas immer eine basale Spaltebene hat – wenn man in diese Richtung Kraft ausübt, spaltet sich der Stein. Die Operation begann mit einer einjährigen Planungsphase, in der der Stein examiniert und das eigentliche Schleifen und Polieren vorbereitet wurde.`,
      },
      {
        title: {
          firstLine: "VORBEREITUNG",
          secondLine: "AUF DIE GROSSE AUFGABE",
        },
        description: `Die Planung eines großen Schmucksteins – sei es ein Diamant oder Edelstein – ist immer kompliziert und zeitaufwendig. Ein kleiner Fehler kann den gesamten Stein ruinieren. In unserem Fall gab es mehrere Hürden: Zum einen gab es keine Maschinen, um einen solchen Stein zu schleifen, da noch nie ein Juwel dieser Größe bearbeitet wurde. Zum anderen fehlte ein Edelsteinschleifer mit ausreichender Erfahrung im Umgang mit solch einem riesigen Topas. Die Angst war groß, dass beim Polieren Spannungen entstehen und der Stein brechen könnte. Die dritte Herausforderung bestand darin, ein Design zu entwickeln, das nicht langweilig ist – denn ein kleiner Edelstein mit kleinen Facetten funkelt meist viel besser als ein großer.`,
      },
      {
        title: {
          firstLine: "TESTVERSUCHE UND",
          secondLine: "SIMULATIONEN DES ENDERGEBNISSES",
        },
        description: `Niveau élevé begann mit dem Import von Spezialglas aus Japan, das den gleichen Brechungsindex wie Topas (1,63) hatte. Anschließend sollten fünf Replikate des Rohtopas aus Glas hergestellt werden, um sie in verschiedenen Schliffen zu polieren – vorrangig um die neue Maschine zu testen und zweitens, um aus fünf verschiedenen geometrischen Formen die schönste auszuwählen.`,
      },
      {
        title: {
          firstLine: "GESCHEITERTER",
          secondLine: "VERSUCH",
        },
        description: `Doch der Versuch scheiterte. Das Glas kristallisierte beim Abkühlen und wurde porzellanartig, weshalb die Übung mit einer anderen Glasart wiederholt werden musste.`,
      },
      {
        title: {
          firstLine: "SCHLEIFEN DER",
          secondLine: "GLASPROBEN",
        },
        description: `Das Schleifen der Glasproben selbst dauerte mehr als zwei Jahre. Immer wieder musste die neue Poliermaschine optimiert, neue diamantimprägnierte Polierscheiben gefertigt und das ultrafeine Gewinde des 3-Achsen-Kreuzschlittens verbessert werden.`,
      },
      {
        title: {
          firstLine: "POLIEREN DES",
          secondLine: "GRÖSSTEN EDELSTEINS ALLER ZEITEN",
        },
        description: `Im Jahr 2020 begann schließlich das eigentliche Schleifen des großen Topases. Für das Schleifen seltener und bedeutender Edelsteine gibt es nur einen Ort: Idar-Oberstein. Für ein so komplexes Werk wurde der kompetenteste und erfahrenste Spezialist, der die traditionelle Kunst des Edelsteinschleifens noch beherrscht, ausgewählt – der Lehrer und Schulleiter der Edelsteinschleiferei Idar-Oberstein, Herr Jürgen Christmann.`,
      },
      {
        title: {
          firstLine: "TEAM-WORK",
          secondLine: "",
        },
        description: `Aber einen Edelstein zu bearbeiten, der fast 20 kg wiegt, ist eine schwierige Aufgabe. So fand Niveau élevé einen Spitzenkünstler im Glasschleifen, Samuel Weisenborn, der sich bereit erklärte, Jürgen zu unterstützen.`,
      },
      {
        title: {
          firstLine: "DIE DRACHENGRAVUR",
          secondLine: "",
        },
        description: `Der Drache auf dem Edelstein wurde von Frau Iris Hartenberger graviert.`,
      },
      {
        title: {
          firstLine: "ZWEI JAHRE BIS",
          secondLine: "ZUM LETZTEN SCHLIFF",
        },
        description: `Zwei Jahre dauerte es schließlich, bis der letzte Feinschliff wenige Tage vor dem Sommer-Event von Niveau élevé, Mitte August 2023, fertig war. Alle drei Experten leisteten großartige Arbeit und schufen einen Edelstein, der alle Erwartungen übertraf!`,
      },
      {
        title: {
          firstLine: "ZERTIFIZIERUNG",
          secondLine: "",
        },
        description: `Im Mai 2024 wurde der Secret Rainbow von Gubelin in Luzern – dem weltweit renommiertesten Edelsteinprüflabor – zertifiziert und erhielt einen hervorragenden Report sowie Kommentar.`,
      },
      {
        title: {
          firstLine: "GRÖSSTER",
          secondLine: "JEMALS GETESTETER TOPAS",
        },
        description: `Es wurde festgestellt, dass der Stein extrem groß ist, einen hohen Transparenzgrad aufweist (da kaum Einschlussstellen sichtbar sind) und dass ein Topas von solch hoher Edelsteinqualität in dieser außergewöhnlichen Größe nur selten vorkommt. Außerdem sei dies der größte Topas, den das Gubelin-Labor je untersucht habe.`,
      },
      {
        title: {
          firstLine: "DIE OKKULTEN KRÄFTE",
          secondLine: "DES TOPAS GEMÄSS DER ANTIKE",
        },
        description: `Edelsteine besitzen eine Wirkung. Heute schätzen wir vor allem deren ästhetische Ausstrahlung, das Feuer, das Lichtspiel, die tiefen und teilweise seltenen Farben sowie die Harmonie ihrer Geometrie. Neben dem hohen Wert und der Seltenheit ist auch der Prestigewert wichtig. In der Antike wurden Steine jedoch auch primär wegen ihrer okkulten Kräfte geschätzt.
Die alten Griechen glaubten, dass Topas ihnen Kraft verleiht, Schlaflosigkeit heilen kann und eine heilende Wirkung auf Geisteskrankheiten besitzt. Die Römer vertrauten dem Topas den Schutz vor Gift zu und meinten, er würde bei Gefahr seine Farbe ändern. Im alten Ägypten wurde dem goldenen Topas sein Leuchten vom Sonnengott Ra zugeschrieben – wodurch er zu einem mächtigen Talisman gegen Unheil wurde. Die Ägypter schrieben diesem Stein auch übernatürliche Kräfte zu.`,
      },
      {
        title: {
          firstLine: "TOPAS IM ALTEN INDIEN",
          secondLine: "UND IN EUROPA",
        },
        description: `In Indien trug man Topas über dem Herzen, was langes Leben, Schönheit und Intelligenz versprach. Im späten Mittelalter und in der Renaissance in Europa sollte der Topas vor bösem Zauber und Ärger schützen.
Auf jeden Fall ist klar, dass ein schöner, seltener und wertvoller Edelstein eine gewisse Kraft besitzt – ob diese psychologischer Natur ist (Stärkung des Selbstbewusstseins) oder metaphysisch/okkult, bleibt letztlich unerheblich. Wir können ohnehin nicht hinter den Vorhang schauen, der unser Verständnis beschränkt.`,
      },
      {
        title: {
          firstLine: "DER ETYMOLOGISCHE URSPRUNG",
          secondLine: "DES NAMENS TOPAS",
        },
        description: `Es gibt zwei Theorien, woher der Name "Topas" stammt. Möglicherweise sind beide gleichzeitig richtig. Plinius der Ältere schrieb in seiner "historia naturalis", dass es – nach Juba – auf einer bestimmten Insel im Roten Meer einen Kristall gibt, wie auch auf einer anderen benachbarten Insel, die den als "Topas" bekannten Edelstein hervorbringt; diese Insel wurde im Altgriechischen Τοπάζιος (Topázios) oder Τοπάζιον (Topázion) genannt.`,
      },
      {
        title: {
          firstLine: "DER NAME 'TOPAS'",
          secondLine: "IST MIT DEM SANSKRITWORT 'TAPAS' VERBUNDEN",
        },
        description: `Laut Alexander Polyhistor, einem antiken griechischen Schriftsteller, stammt der etymologische Ursprung des Namens Topas – sowohl für den Edelstein als auch für die Insel, die man als dessen Produzent betrachtete – aus dem alten Sri Lanka, das Topas nach Ägypten und Griechenland exportierte. Dies deutet darauf hin, dass der Name Topas auf das Sanskrit-Wort तपस् zurückgeht, was "Hitze" oder "Feuer" bedeutet.
Wenn dies der wahre Ursprung ist, gibt es eine interessante Parallele zur Symbolik des Secret Rainbow: Die Hauptbedeutung des Sanskrit-Wortes Tapasya (तपस्य), das wörtlich "Hitze erzeugen" bedeutet, beschreibt den Bemühens, höhere Bewusstseinsebenen zu erreichen, Selbstverwirklichung zu erlangen und schlussendlich in eine Vereinigung mit dem Göttlichen einzutreten.`,
      },
      {
        title: {
          firstLine: "DEN GRÖSSTEN",
          secondLine: "FACETTIERTEN EDELSTEIN DER WELT ZU BESITZEN",
        },
        description: `Ein Juwel oder einen Schatz zu besitzen, ist einer der ureigensten Instinkte der Menschen – von Anbeginn der Geschichte bis heute. Dieser Wunsch mag auf unterschiedliche Mechanismen zurückgeführt werden, doch der Besitz eines mächtigen Edelsteins verleiht Stärke, Selbstbewusstsein und innere Kraft, die weit über rein psychologische Erklärungen hinausgehen. Und seien wir froh, dass nicht alle Geheimnisse entdeckt oder erklärt wurden. Wir sollten einfach anerkennen, dass ein fantastischer Edelstein eine gewisse Kraft besitzt – was auch immer dies bedeuten mag!
Den größten facettierten Edelstein der Welt zu besitzen, verleiht der Marke Niveau élevé natürlich zusätzlich Wert und Kraft. Es ist zudem eines der erklärten Hauptziele von Niveau élevé, sich mit dem jenseits des Sichtbaren und Erklärbaren zu beschäftigen. Mit anderen Worten: Wer ein Schmuckstück oder eine Uhr von Niveau élevé besitzt, trägt einen Teil der Kraft des Secret Rainbow in sich – ganz so, wie die moderne Physik (durch quantenphysikalische Experimente) bewiesen hat, dass Dinge aus dem gleichen Ursprung auch über Millionen von Kilometern hinweg miteinander verbunden bleiben. Wir glauben daher, dass jedes Stück der Marke Niveau élevé etwas vom gemeinsamen Ursprung in sich trägt und hoffen, dass sich die Kraft dieses Topases, des größten aller facettierten Edelsteine, in jedem Mitglied der Niveau élevé-Familie manifestiert.`,
      },
    ],
  },
  fr: {
    backgroundTitle: {
      firstLine: "L'ARC-EN-CIEL",
      secondLine: "SECRET"
    },
    intro: {
      title: {
        firstLine: "L'ARC-EN-CIEL SECRET,",
        secondLine: "LA PLUS GRANDE PIERRE PRÉCIEUSE AU MONDE"
      },
      description:
        "La pierre précieuse qui détient la couronne parmi les joyaux, la plus grande de toutes les gemmes facettées, est le Secret Arc-en-ciel. Cette gemme exceptionnelle n'est pas seulement la Mère de toutes les Gemmes par sa taille. Elle possède également un fantastique Arc-en-ciel, très rarement trouvé dans une pierre précieuse. Les couleurs d'interférence, visibles à différents endroits de la gemme lorsque la lumière frappe la pierre dans une direction particulière, sont parmi les plus intenses jamais trouvées dans un joyau.",
    },
    timeline: [
      {
        title: {
          firstLine: "LE SECRET ARC-EN-CIEL,",
          secondLine: "UNE TOPAZE NOBLE DE 50 200 CARATS",
        },
        description: `Le Secret Arc-en-ciel, une topaze noble de 50 200 carats, pèse plus d'une fois et demie le poids de la deuxième plus grande gemme, l'El Dorado avec ses 31 000 carats.
La taille particulière du plus grand joyau sur terre est une combinaison d'une taille à degrés sur la face avant et d'un arrangement de rainures de culasse à l'arrière. Les rainures arrière sont sculptées avec l'angle critique de la topaze, qui offre la meilleure réflexion de la lumière.
Placé à la verticale, l'arrangement des rainures évoque un lever de soleil au petit matin, avec l'arc-en-ciel se déployant haut dans le ciel. Comme troisième élément, un dragon est sculpté sur un côté de la topaze, jouant avec l'arc-en-ciel.`,
      },
      {
        title: {
          firstLine: "LE DRAGON,",
          secondLine: "UN POUVOIR SURNATUREL",
        },
        description: `Un dragon est une figure mythologique qui apparaît dans toutes les cultures anciennes du monde entier. Comme aucun animal n'aurait pu servir de prototype aux croyances sur les dragons, les scientifiques se demandent d'où vient cette figure mythique. Elle apparaît dans la culture des Mayas ainsi que de l'autre côté du globe, en Australie. Elle est présente en Chine et dans les îles polynésiennes, en Inde, en Europe, en Afrique ; elle figure dans les croyances des anciens Vikings et dans le christianisme – elle est tout simplement partout !`,
      },
      {
        title: {
          firstLine: "LE DRAGON,",
          secondLine: "ARCHÉTYPE UNIVERSEL",
        },
        description: `Et comment se fait-il que cet être mythique apparaisse indépendamment dans toutes les cultures avec exactement les mêmes caractéristiques ? S'il n'y a pas de prototype dans le monde extérieur, alors la figure mythique du dragon doit être une réplique d'un exemple des mondes intérieurs ! Évidemment, les dragons existent – comme les fées ou les gobelins – qui apparaissent également dans toutes les cultures, mais il faut un œil intérieur bien entraîné pour les voir.`,
      },
      {
        title: {
          firstLine: "LE DRAGON,",
          secondLine: "SES DIFFÉRENTS VISAGES",
        },
        description: `Et comme d'autres entités, les dragons représentent une force ou un aspect particulier dans les mondes occultes. Bien que la physionomie de tous les dragons soit à peu près la même – y compris leurs traits de caractère – l'évaluation du dragon change radicalement d'une culture à l'autre. Alors qu'en Europe, le dragon est considéré comme un monstre sauvage créant chaos et destruction, en Asie, il est considéré comme un être sage et doux, un symbole de chance et de prospérité. Quelques traits de caractère du dragon sont cependant communs à toutes les cultures : son affinité pour les trésors et son instinct à les garder et à les défendre.`,
      },
      {
        title: {
          firstLine: "L'ARC-EN-CIEL,",
          secondLine: "UN PONT ENTRE LE CIEL ET LA TERRE",
        },
        description: `L'arc-en-ciel symbolise dans toutes les cultures une connexion entre le divin et le terrestre. Dans la mythologie grecque, la déesse Iris – la messagère céleste – descend sur l'arc-en-ciel. Dans la mythologie viking, l'arc-en-ciel est le pont entre le Midgard (notre monde) et Asgard, le monde des dieux.`,
      },
      {
        title: {
          firstLine: "L'ARC-EN-CIEL,",
          secondLine: "GARDIEN DU PLUS GRAND TRÉSOR",
        },
        description: `L'image d'un dragon devant un arc-en-ciel peut symboliser de nombreuses choses. Ici, l'image symbolique est celle d'un dragon gardant le trésor le plus précieux qui existe : l'entrée vers les mondes divins, vers la sagesse, la connaissance, les pouvoirs magiques illimités et la béatitude sans limites. Le dragon garde ce trésor en dirigeant notre attention vers les petits détails de la vie quotidienne afin que nous ne trouvions pas la porte des mondes intérieurs cachée en nous.`,
      },
      {
        title: {
          firstLine: "LE 'SECRET ARC-EN-CIEL'",
          secondLine: "ET SON SYMBOLISME",
        },
        description: `Le "corps" de la plus grande gemme du monde – avec sa taille spéciale représentant un lever de soleil – symbolise le début du jour, le temps, notre journée ou notre époque, la vie elle-même.`,
      },
      {
        title: {
          firstLine: "AU CŒUR",
          secondLine: "DE LA GEMME",
        },
        description: `Au cœur de la gemme, au centre de notre vie, se trouve (symbolisé par la tache d'arc-en-ciel) le grand objectif vers lequel nous voyageons tous : l'entrée vers des niveaux supérieurs de conscience, vers les royaumes divins, vers la béatitude illimitée, et la transformation de toutes les limitations et imperfections.`,
      },
      {
        title: {
          firstLine: "LE DRAGON",
          secondLine: "GARDE LE TRÉSOR",
        },
        description: `Cependant, cette entrée – le plus grand trésor que chacun porte dans son cœur – est gardée par un dragon qui s'assure que nous ne la trouvions jamais. Par son jeu et le jeu de la vie, il détourne notre attention vers les petits détails de la vie, de sorte que nous sommes aveugles à la porte menant aux mondes intérieurs ; une porte qui est cachée mais qui, sous un certain angle, révèle une lumière irisée indiquant qu'elle est en fait grande ouverte !`,
      },
      {
        title: {
          firstLine: "DÉCOUVERTE DE LA PLUS GRANDE",
          secondLine: "PIERRE PRÉCIEUSE DU MONDE",
        },
        description: `Il y a des choses dans la vie qui n'arrivent qu'une fois, et une fois qu'elles se produisent, vous savez qu'il n'y aura jamais de seconde fois ! Lorsqu'en 2017, une topaze brute de taille inhabituelle et d'une excellente pureté a croisé le chemin de Niveau élevé, l'énorme potentiel contenu dans ce futur roi de toutes les gemmes n'était pas apparent pour le négociant afghan de pierres brutes qui l'offrait. La pierre avait été découverte un an plus tôt au Brésil (Minas Gerais) et avait changé de mains plusieurs fois – mais personne n'avait la compétence ou la vision pour la transformer en la plus grande pierre précieuse jamais polie.`,
      },
      {
        title: {
          firstLine: "LE PRIX DE LA",
          secondLine: "TOPAZE BRUTE PURE",
        },
        description: `Ainsi, la topaze brute a été proposée au prix standard pour le brut pur – un prix auquel la pierre, généralement sciée en petits morceaux, polie en gemmes pour bagues ou pendentifs, irradiée, puis vendue comme "topaze bleue" dans le télé-shopping ou par de grands discounters, était commercialisée. Mais ce n'était pas ce que Niveau élevé avait en tête ! Étant pleinement dans les grandes sculptures de pierres précieuses, ils savaient que les trois plus grandes gemmes connues étaient toutes des topazes nobles, et cette incroyable pièce brute pourrait éventuellement les battre toutes ! À cette époque, la plus grande pierre précieuse du monde était l'El Dorado dans une collection spéciale à Madrid, pesant 31 000 carats. La "Topaze Dorée Américaine" de 22 892 carats, exposée au Musée National d'Histoire Naturelle à Washington, arrivait en deuxième position.`,
      },
      {
        title: {
          firstLine: "LE LONG CHEMIN",
          secondLine: "VERS LE POLISSAGE",
        },
        description: `Après l'achat de la méga-gemme, il a fallu encore cinq ans pour la polir jusqu'à ce qu'elle est maintenant. Il y avait plusieurs difficultés majeures. La plus critique était que la topaze a toujours un plan de clivage basal qui la traverse – si vous appliquez une force le long de ce plan lors de la coupe, la topaze se divisera simplement en deux. L'opération a commencé par une année complète de planification où la pierre a été étudiée et la coupe et le polissage préparés.`,
      },
      {
        title: {
          firstLine: "PRÉPARATION POUR",
          secondLine: "LA GRANDE TÂCHE",
        },
        description: `Planifier un grand joyau – qu'il s'agisse d'un diamant ou d'une pierre précieuse – est toujours compliqué et prend du temps. Une petite erreur peut ruiner toute la pierre. Dans notre cas, plusieurs obstacles ont dû être surmontés : premièrement, il n'y avait pas de machinerie pour polir une telle pierre ; aucun équipement n'existait pour une gemme de cette ampleur. Une nouvelle machine a dû être conçue et construite. Deuxièmement, il n'y avait pas de polisseur de pierres précieuses suffisamment expérimenté avec une topaze aussi énorme. La crainte était que les tensions de polissage puissent conduire à la rupture de la pierre. Le troisième défi était de développer un design qui ne serait pas ennuyeux – après tout, une petite gemme avec de petites facettes brille bien mieux qu'une grande.`,
      },
      {
        title: {
          firstLine: "ÉCHANTILLONNAGE DU",
          secondLine: "RÉSULTAT FINAL",
        },
        description: `Niveau élevé a commencé par importer du verre spécial du Japon avec le même indice de réfraction que la topaze (1,63). Ensuite, cinq répliques de la topaze brute ont été moulées en verre afin qu'elles puissent être polies dans différentes tailles – principalement pour tester la nouvelle machine, et secondairement pour choisir la forme géométrique la plus belle pour la pierre précieuse.`,
      },
      {
        title: {
          firstLine: "TENTATIVE",
          secondLine: "ÉCHOUÉE",
        },
        description: `Mais la tentative a échoué. Le verre s'est cristallisé pendant le refroidissement et est devenu comme de la porcelaine, donc le processus a dû être répété avec un type de verre différent.`,
      },
      {
        title: {
          firstLine: "POLISSAGE DES",
          secondLine: "ÉCHANTILLONS DE VERRE",
        },
        description: `Le polissage des échantillons de verre a pris plus de deux ans. Encore et encore, la nouvelle machine de polissage a dû être optimisée, de nouvelles roues de polissage imprégnées de diamant ont dû être fabriquées, ou le filetage ultra-fin de la table croisée à 3 axes amélioré.`,
      },
      {
        title: {
          firstLine: "POLISSAGE DE LA PLUS",
          secondLine: "GRANDE GEMME JAMAIS CRÉÉE",
        },
        description: `Finalement, en 2020, le polissage réel de la grande topaze a commencé. Pour le polissage de pierres précieuses rares et importantes, il n'y a qu'un seul endroit au monde – Idar-Oberstein. Pour une tâche aussi complexe, le spécialiste le plus compétent et expérimenté (qui connaît encore l'art traditionnel de la taille fine des gemmes) a été choisi : le professeur et directeur de l'École de Taille de Gemmes d'Idar-Oberstein, M. Jürgen Christmann.`,
      },
      {
        title: {
          firstLine: "TRAVAIL",
          secondLine: "D'ÉQUIPE",
        },
        description: `Mais manipuler une pierre précieuse pesant près de 20 kg est une tâche redoutable. Niveau élevé a donc fait appel à un artiste de premier plan dans la taille du verre, Samuel Weisenborn, qui a accepté d'assister Jürgen.`,
      },
      {
        title: {
          firstLine: "SCULPTURE",
          secondLine: "DU DRAGON",
        },
        description: `Le dragon sur la pierre précieuse a été sculpté par Mme Iris Hartenberger.`,
      },
      {
        title: {
          firstLine: "DEUX ANS JUSQU'AU",
          secondLine: "POLISSAGE FINAL",
        },
        description: `Il a fallu deux ans jusqu'à ce que le polissage final soit terminé quelques jours seulement avant l'événement d'été de Niveau élevé à la mi-août 2023. Les trois experts ont fait un travail merveilleux, livrant une gemme qui a dépassé toutes les attentes !`,
      },
      {
        title: {
          firstLine: "CERTIFICATION",
          secondLine: "",
        },
        description: `En mai 2024, Gubelin à Lucerne, en Suisse – le laboratoire d'essai de pierres précieuses le plus réputé au monde – a certifié le Secret Arc-en-ciel et a émis un rapport et un commentaire exceptionnels.`,
      },
      {
        title: {
          firstLine: "LA PLUS GRANDE TOPAZE",
          secondLine: "JAMAIS TESTÉE",
        },
        description: `Il a été déclaré que la pierre est extrêmement grande, a un haut degré de transparence (avec peu d'inclusions visibles à l'œil nu), et qu'une topaze de qualité gemme est rarement vue dans une taille aussi exceptionnelle. De plus, c'est la plus grande topaze jamais testée par le laboratoire Gubelin.`,
      },
      {
        title: {
          firstLine: "LES POUVOIRS OCCULTES DE LA TOPAZE",
          secondLine: "SELON L'HISTOIRE",
        },
        description: `Les pierres précieuses ont un effet. Aujourd'hui, nous apprécions surtout leur attrait esthétique, leur feu, leur jeu de lumière, leurs couleurs profondes ou rares, et leur géométrie harmonieuse. Outre leur valeur élevée et leur rareté, ces aspects contribuent à leur prestige. Dans les temps anciens, les pierres étaient également principalement valorisées pour leurs pouvoirs occultes.
Les anciens Grecs croyaient que la topaze leur donnait de la force, guérissait l'insomnie et les maladies mentales. Les Romains pensaient qu'elle pouvait protéger contre le poison et changerait de couleur lorsque le danger était proche. Dans l'Égypte ancienne, on croyait que la topaze dorée recevait son éclat du dieu soleil Râ – ce qui en faisait un puissant talisman contre le mal. Les Égyptiens attribuaient également des pouvoirs surnaturels à cette pierre précieuse.`,
      },
      {
        title: {
          firstLine: "LA TOPAZE DANS L'INDE ANCIENNE",
          secondLine: "ET AU-DELÀ",
        },
        description: `En Inde, la topaze était portée sur le cœur – un symbole de longue vie, de beauté et d'intelligence. À la fin du Moyen Âge et pendant la Renaissance en Europe, on disait que la topaze protégeait contre les mauvais sorts et la colère.
Dans tous les cas, il est clair qu'une pierre précieuse belle, rare et précieuse porte un certain pouvoir – que cet effet soit psychologique (renforçant la confiance en soi) ou métaphysique/occulte reste immatériel. Nous ne pouvons simplement pas voir derrière le rideau qui limite notre compréhension de tous ces mécanismes invisibles.`,
      },
      {
        title: {
          firstLine: "L'ORIGINE ÉTYMOLOGIQUE",
          secondLine: "DU NOM TOPAZE",
        },
        description: `Il existe deux théories concernant l'origine du nom "Topaze" – peut-être que les deux sont vraies. Nous savons que Pline l'Ancien a écrit dans son "historia naturalis" que, selon Juba, il y a un cristal sur une certaine île de la mer Rouge ainsi que sur une autre île voisine qui produit la pierre précieuse connue sous le nom de "topazus" ; cette île s'appelait en grec ancien Τοπάζιος (Topázios) ou Τοπάζιον (Topázion).`,
      },
      {
        title: {
          firstLine: "LE NOM 'TOPAZE'",
          secondLine: "LIÉ AU SANSKRIT 'TAPAS'",
        },
        description: `Selon Alexandre Polyhistor, un écrivain grec ancien, l'origine étymologique du nom topaze – pour la pierre précieuse et l'île censée la produire – venait de l'ancien Sri Lanka, qui exportait la topaze vers l'Égypte et la Grèce. Cela indique que le nom topaze est lié au mot sanskrit तपस् "tapas", signifiant "chaleur" ou "feu".
Si c'est la véritable origine du nom topaze, il y a un parallèle intéressant avec le symbolisme du Secret Arc-en-ciel : la signification principale du mot sanskrit Tapasya (तपस्य), qui signifie littéralement "générer de la chaleur", est l'effort pour atteindre des niveaux supérieurs de conscience, pour réaliser la connaissance de soi, et finalement, pour expérimenter l'union avec le Divin.`,
      },
      {
        title: {
          firstLine: "POSSÉDER LA PLUS GRANDE",
          secondLine: "PIERRE PRÉCIEUSE FACETTÉE DU MONDE",
        },
        description: `Posséder un joyau ou un trésor est l'un des instincts humains les plus intrinsèques à travers toute l'histoire – même aujourd'hui. Bien que divers mécanismes puissent expliquer ce désir, posséder une pierre précieuse puissante confère force, confiance en soi et pouvoir intérieur qui va au-delà de la simple psychologie. Et soyons heureux que tous les mystères n'aient pas été découverts ou expliqués. Apprécions simplement qu'une gemme fantastique ait son propre pouvoir, quel qu'il soit !
Posséder la plus grande pierre précieuse facettée du monde ajoute naturellement de la valeur et du pouvoir à la marque Niveau élevé. De plus, l'un des objectifs déclarés de Niveau élevé est de travailler avec ce qui se trouve au-delà du visible ou de l'explicable. En bref, posséder une pièce de joaillerie ou une montre de Niveau élevé signifie posséder une partie – et puiser dans – le pouvoir du Secret Arc-en-ciel ! La physique moderne (via des expériences quantiques-optiques) a prouvé que des parties de la même origine restent liées même sur des millions de kilomètres. Ainsi, nous croyons que chaque pièce de Niveau élevé porte une trace de chaque autre produit de la même origine, et nous espérons que la force de cette topaze – la plus grande de toutes les gemmes facettées – se manifeste dans chaque membre de la famille Niveau élevé.`,
      },
    ],
  },
  zh: {
    backgroundTitle: {
      firstLine: "秘密",
      secondLine: "彩虹"
    },
    intro: {
      title: {
        firstLine: "秘密彩虹，",
        secondLine: "世界上最大的刻面寶石"
      },
      description:
        "「秘密彩虹」是所有刻面寶石中最大的寶石, 在珠寶中握有桂冠的寶石。這顆最非凡的寶石不僅憑藉其尺寸而被稱為所有寶石之母。它還擁有在寶石中非常罕見的奇妙彩虹。當光線以特定方向照射到這顆寶石上，在寶石的不同位置看到的干涉色彩，肯定是寶石中最強烈的色彩之一。"
    },
    timeline: [
      {
        title: {
          firstLine: "秘密彩虹，",
          secondLine: "50.200卡的稀有托帕石"
        },
        description: `秘密彩虹，50.200卡的稀有托帕石，比起第二大寶石31.000卡的埃爾多拉多（El Dorado），重量超過其1.5 倍。
這顆地球上最大寶石的獨特切割，是正面的階梯式切割和背面的底面凹槽排列的組合。背面的凹槽按照托帕石所謂的臨界角雕刻，以實現最佳的光線反射。
當直立放置時，凹槽的排列呈現清晨日出的景象，彩虹在高空展開。作為第三個元素，一條龍被雕刻在托帕石的一側，與彩虹嬉戲。`
      },
      {
        title: {
          firstLine: "龍，",
          secondLine: "一種超自然力量"
        },
        description: `龍是世界各地所有古代文化中都有出現的神話生物。由於沒有任何動物可以作為龍信仰的原型，科學家想知道這個神話生物從何而來。它出現在瑪雅人的文化中，也出現在地球另一端的澳洲。它也在中國、波利尼西亞群島、印度、歐洲和非洲；它出現在古代維京人和基督教的信仰中——它無處不在！`
      },
      {
        title: {
          firstLine: "龍，",
          secondLine: "普世原型"
        },
        description: `這個神話生物如何會在所有文化中獨立出現，並且具有完全相同的特徵呢？如果外在世界沒有原型，那麼龍的神話形象就一定是內在世界某一範例的複製品！顯然，龍確實存在，就像仙子或哥布林一樣，它們也出現在所有文化中，但需要經過良好訓練的「內視」才能看到它們。`
      },
      {
        title: {
          firstLine: "龍，",
          secondLine: "不同面貌"
        },
        description: `和其他實體一樣，龍在神秘世界中代表著一種特殊力量或面向。雖然所有龍的外形和性格特徵都大致相同，但對龍的評價在不同文化中卻有很大差異。在歐洲，龍被視為製造混亂和破壞的怪物；在亞洲，龍則被視為智慧而溫和的生物，是幸運和繁榮的象徵。然而，龍的一些性格特徵在所有文化圈中都是共通的：對寶藏的喜愛，以及守護和捍衛寶藏的本能。`
      },
      {
        title: {
          firstLine: "彩虹，",
          secondLine: "天地之間的橋樑"
        },
        description: `在所有文化中，彩虹象徵著神聖與塵世之間的連結。在希臘神話中，女神伊麗絲作為天使從彩虹降臨到我們身邊。在維京神話中，彩虹是中土世界（我們的世界）和諸神世界之間的連結橋樑。`
      },
      {
        title: {
          firstLine: "彩虹，",
          secondLine: "守護至寶"
        },
        description: `彩虹前的龍畫像可以象徵很多事物。於此象徵的圖像是龍守護著現存最珍貴的寶藏：通往神聖世界的入口，通往智慧、知識、無限魔力和無限幸福的入口。龍守護著這個寶藏，將我們全部注意力引向日常生活中的小事，讓我們找不到隱藏在我們每個人心中的神聖世界大門。`
      },
      {
        title: {
          firstLine: "「秘密彩虹」",
          secondLine: "及其象徵意義"
        },
        description: `這顆世界上最大寶石的「主體」，以其特殊切割方式描繪出日出，象徵著一天的開始、時間、我們的一天或我們的時間，以及生命本身。`
      },
      {
        title: {
          firstLine: "寶石的核心",
          secondLine: ""
        },
        description: `在寶石的中心，在我們生活的中心，以彩虹斑塊為象徵，矗立著我們所有人都朝著行進的大目標：通往更高意識層次的入口，通往神聖境界的入口，通往無限幸福以及將一切限制和不足轉化的入口。`
      },
      {
        title: {
          firstLine: "龍守護寶藏",
          secondLine: ""
        },
        description: `然而，這個入口——每個人內心都藏著的最大寶藏——有一條龍守護著，它確保我們不會找到這個寶藏。透過它的遊戲和生活的遊戲，它將我們的注意力轉移到生命的枝節，致使我們看不見通往內在世界的大門；這扇門是隱藏的，只有在特定角度才能看到透出的彩虹光芒，表明這扇門實際上是敞開的！`
      },
      {
        title: {
          firstLine: "發現世界上最大的",
          secondLine: "寶石"
        },
        description: `生命中有些事只能做一次，而且知道永遠不會有第二次！2017年，當一顆大小極為罕見且純度極高的托帕石原石出現在Niveau élevé的面前時，阿富汗原石經銷商並沒有意識到它所蘊含的巨大潛力。這顆寶石於一年前在巴西（米納斯吉拉斯州）被發現，並數度易手，但沒有人有能力或遠見將它打磨成史上最大的寶石。`
      },
      {
        title: {
          firstLine: "純淨黃托帕石原石的",
          secondLine: "價格"
        },
        description: `關於純淨黃托帕石原石的價格，一般情況是：它們會被切割成小塊，用作戒指或吊墜的寶石，經過輻射處理後，以「藍色托帕石」的形式在電視購物或大型折扣店大量售出。
但這並不是Niveau élevé想做的！他們深諳大型寶石雕塑之道，知道已知的三大寶石全是稀有黃托帕石，而這塊驚人的原石有可能超越它們！當時，世界上最大的寶石是「埃爾多拉多」，位於馬德里的一個特殊收藏中，重達31,000卡。其次是「美國金色托帕石」（22,892卡），收藏於華盛頓的國家自然史博物館。`
      },
      {
        title: {
          firstLine: "漫長",
          secondLine: "拋光之路"
        },
        description: `這顆巨型寶石被購買之後，花了五年的時間才打磨成如今的模樣。期間困難重重，其中最關鍵的是托帕石總有一條穿透整塊石頭的基底解理面；如果在切割時沿著解理面方向用力，寶石便會裂成兩半。
為了避免這種情況，整個工程從為期一年的規劃開始，仔細研究這塊石頭，並規劃切割與拋光工序。`
      },
      {
        title: {
          firstLine: "為重大任務",
          secondLine: "做好準備"
        },
        description: `無論是大鑽石或大寶石，規劃大型珠寶都相當複雜且耗時；一個小錯誤就可能毀掉整塊寶石。此案的障礙不只一個：首先，從未出現過如此巨大的寶石，市場上沒有任何可用來拋光它的機器，必須從零開發。其次，沒有人具備拋光如此巨型托帕石的經驗，大家都擔心拋光時產生的張力會導致石頭碎裂。第三，必須設計出不會令人感到單調的切割方式——畢竟小寶石的細微刻面往往比大寶石更閃耀迷人。`
      },
      {
        title: {
          firstLine: "最終結果的",
          secondLine: "抽樣"
        },
        description: `Niveau élevé首先從日本進口折射率與托帕石（1.63）相同的特殊玻璃，並以此鑄出五個托帕石原石的複製品，嘗試不同的切割方式。主要目的在於測試新研發的拋光機，其次才是從五種幾何造型中選出最美的一種。`
      },
      {
        title: {
          firstLine: "失敗的",
          secondLine: "嘗試"
        },
        description: `不過這次嘗試並不成功。玻璃在冷卻過程中結晶，變得像陶瓷一樣，導致整個實驗只能換另一種玻璃重新開始。`
      },
      {
        title: {
          firstLine: "拋光",
          secondLine: "玻璃樣品"
        },
        description: `這些玻璃樣品的拋光作業本身就耗費了兩年多時間。期間需要不斷改進新製的拋光設備，更換新的鑽石浸漬拋光輪，或調整三軸交叉滑座的超細螺紋精度。`
      },
      {
        title: {
          firstLine: "拋光史上",
          secondLine: "最大寶石"
        },
        description: `終於在2020年開始了真正的托帕石拋光工作。拋光稀有且重要的寶石，世界上只有一個地方——伊達爾-奧伯施泰因。在那裡，最精通並仍保留傳統寶石切割工藝的專家——伊達爾-奧伯施泰因寶石切割學校的導師兼校長Jürgen Christmann——擔任此任務。`
      },
      {
        title: {
          firstLine: "團隊合作",
          secondLine: ""
        },
        description: `但要處理一顆近20公斤重的寶石絕非易事。Niveau élevé於是請來頂尖的玻璃切割藝術家Samuel Weisenborn，他同意一起協作，協助Jürgen完成工作。`
      },
      {
        title: {
          firstLine: "龍雕",
          secondLine: ""
        },
        description: `寶石上的龍是由Iris Hartenberger女士雕刻完成的。`
      },
      {
        title: {
          firstLine: "距離最終拋光還有",
          secondLine: "兩年時間"
        },
        description: `從開始到最後的拋光完成，總共耗時兩年；在2023年8月中旬Niveau élevé夏季活動開始的前幾天才全面竣工。三位專家出色地完成了任務，呈現出超乎所有人預期的寶石作品！`
      },
      {
        title: {
          firstLine: "認證",
          secondLine: ""
        },
        description: `2024年5月，全球最負盛名的寶石檢測實驗室——瑞士盧塞恩的Gubelin——對「秘密彩虹」進行了認證，並給出了一份極為優秀的報告與評語。`
      },
      {
        title: {
          firstLine: "迄今測試過的",
          secondLine: "最大的黃托帕石"
        },
        description: `報告指出，此石極為巨大，並且由於幾乎沒有肉眼可見的內含物而擁有極高透明度，同時如此卓越尺寸的黃托帕石在寶石領域也極為罕見。報告還強調，這是Gubelin實驗室迄今測試過的最大黃托帕石。`
      },
      {
        title: {
          firstLine: "歷史上關於黃托帕石的",
          secondLine: "神秘力量"
        },
        description: `寶石確實帶有某種影響力。如今，我們多重視它們的美學魅力、火彩、光影變化、色彩深度與稀有性以及幾何結構的和諧度。此外，珍貴與稀有本身也帶來聲望。但在古代，人們主要甚至優先看重的是寶石的神秘力量。
古希臘人相信托帕石能賦予他們力量，治癒失眠，並對精神疾病有療效。古羅馬人認為托帕石可以防毒，且在危險臨近時會改變顏色。古埃及則傳說金色托帕石的光芒來自太陽神拉，使它成為一種能抵禦危害的強力護身符。他們也將超自然力量歸於此石。`
      },
      {
        title: {
          firstLine: "古印度及其他地方的",
          secondLine: "黃托帕石"
        },
        description: `在印度，人們把托帕石戴在心口，認為這能帶來長壽、美麗與智慧。到了歐洲的中世紀晚期和文藝復興時期，也流傳著托帕石可防惡咒和憤怒的說法。
無論如何，一顆美麗、稀有且珍貴的寶石確實承載著某種力量；這股力量也許是心理層面的（提升自信）或形而上學、神秘層面的。我們無法窺探所有看不見的運作機制。`
      },
      {
        title: {
          firstLine: "黃托帕石名稱的字源",
          secondLine: ""
        },
        description: `關於「托帕石」名稱的起源，有兩種理論，也可能同時正確。老普林尼在《自然史》中曾提到：根據朱巴（Juba）的說法，在紅海的某個島上以及附近另一座島上都有這種被稱為「topazus」的珍貴石頭；在古希臘語中，該島被稱為Τοπάζιος (Topázios) 或 Τοπάζιον (Topázion)。`
      },
      {
        title: {
          firstLine: "名稱「TOPAZ」",
          secondLine: "與梵語「TAPAS」相關"
        },
        description: `根據古希臘作家亞歷山大·波利希斯托（Alexander Polyhistor）的說法，托帕石以及出產這種寶石的島嶼之名，都源自古代斯里蘭卡，當時斯里蘭卡曾向埃及和希臘出口黃托帕石，顯示「托帕石」一詞與梵語 तपस्「tapas」（意為「熱」或「火」）有關。
若此為托帕石名稱的真正由來，那它與「秘密彩虹」所代表的象徵意義就有了有趣的呼應：梵語Tapasya（तपस्य）字面意為「產生熱量」，其主要意義是努力追求更高的意識層次、達成自我實現，並最終與神合一。`
      },
      {
        title: {
          firstLine: "擁有全世界最大的",
          secondLine: "刻面寶石"
        },
        description: `從古至今，擁有珠寶或寶藏一直是人類最根本的渴望之一。有人嘗試用各種機制來解釋這種慾望，但不可否認，手握強大寶石能帶來力量、自信與深層的內在能量，這不僅僅是心理作用可概括的。
對Niveau élevé而言，世上最大的刻面寶石無疑提高了其價值與影響力。更何況，Niveau élevé一向著重探索超越表象與可解釋範疇的種種奧祕。擁有一件Niveau élevé的珠寶或腕錶，便是擁有並接通了「秘密彩虹」的力量；現代物理學的量子實驗顯示，同源之物即使相距數百萬公里，依舊以某種方式彼此相連。我們相信，Niveau élevé的每件作品都承載著彼此的部分力量，也期盼這顆全球最大的刻面托帕石所蘊含的能量，能在Niveau élevé家族的所有成員中展現。`
      }
    ]
  }
};

export function getBiggestGemstoneTranslations(language: Language): BiggestGemstoneTranslations {
  return biggestGemstoneTranslations[language] || biggestGemstoneTranslations.en!;
}